export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/menu-icon-white.f4b9627b.svg","height":18,"width":20};